module.exports = __webpack_public_path__ + "static/media/premierOneRightSeatMobile.93191c7c.svg";